module.exports = __webpack_public_path__ + "img/img29.c6e1931c.png";